import { Navigate } from "react-router";
import useAuth from "hooks/useAuth";

export default function ProtectedUserRoute({ children }) {
  const { userData } = useAuth();

  if (userData?.userName !== "AKIKOADMIN") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}